import { FormControlLabel, RadioGroup } from '@mui/material';
import styled from 'styled-components';

export const StyledRadioGroup = styled(RadioGroup)<{ $weaveTheme: boolean }>(
	({ theme, $weaveTheme }) => {
		return {
			display: 'flex',
			flexDirection: 'row',
			background: $weaveTheme
				? theme.palette.background.default
				: '#43575D',
			borderRadius: '8px',
			padding: '0.5 rem 1rem',
			width: 'fit-content',
		};
	},
);

import { Theme } from '@mui/material/styles';

export const StyledFormControlLabel = styled(FormControlLabel)<{
	$weaveTheme: boolean;
}>(
	({
		theme,
		control,
		$weaveTheme,
	}: {
		theme: Theme;
		control;
		$weaveTheme: boolean;
	}) => {
		const checked = control?.props?.checked || false;
		const checkedTextColor = $weaveTheme
			? theme.palette.primary.main
			: '#fff';
		const checkedCheckboxColor = theme.palette.primary.main;

		// Weave and innovyze specifics
		const unCheckedColor = $weaveTheme
			? theme.palette.text.primary
			: '#768D95';
		const checkedBackgroundColor = $weaveTheme
			? theme.palette.background.paper
			: '#4A6067';

		return {
			backgroundColor: checked && checkedBackgroundColor,
			borderRadius: '8px',
			padding: '4px 8px',
			margin: '0',
			transition: 'background 0.3s',
			color: checked ? checkedTextColor : unCheckedColor,
			'.MuiRadio-colorPrimary': {
				color: checked ? checkedCheckboxColor : unCheckedColor,
			},
		};
	},
);
